import React from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
import CustomLink from '@shared/components/customLink'

function ViewAll({ title, href }) {
  return (
    <CustomLink href={href} passHref>
      <a className='w-100'>
        <button className={styles.btn}>
          <span className={styles.title}>{title}</span>
        </button>
      </a>
    </CustomLink>
  )
}

ViewAll.propTypes = {
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired
}

export default ViewAll
